import { useId } from 'react';

export const SettingsWrapper = ({
    title,
    badge,
    description,
    actions,
    image,
    notificationBanner,
    isLoading,
    condensed,
}: SettingsWrapperProps) => {
    const id = useId();

    return (
        <div className="py-2 flex flex-col gap-1">
            <div className={'flex flex-col md:flex-row md:justify-between md:items-center gap-2'}>
                <div className="md:max-w-[70%] flex gap-4 items-center">
                    {image}
                    <div className="flex flex-col gap-1">
                        <div className="flex gap-1 items-center justify-start">
                            <s-heading>{title}</s-heading>
                            {condensed && (
                                <>
                                    <s-icon type="info" interestFor={id} />
                                    <s-tooltip id={id}>{description}</s-tooltip>
                                </>
                            )}
                            {isLoading ? <div className="w-9 skeleton-block" /> : badge}
                        </div>
                        {!condensed && <s-text color="subdued">{description}</s-text>}
                    </div>
                </div>
                <div className="flex flex-row justify-end">{actions}</div>
            </div>
            {!condensed && notificationBanner}
        </div>
    );
};

interface SettingsWrapperProps {
    title: string;
    badge?: React.ReactNode;
    description: string;
    actions: React.ReactNode;
    image?: React.ReactNode;
    notificationBanner?: React.ReactNode;
    isLoading?: boolean;
    condensed?: boolean;
}
